function getURL(baseURL, businessUUID) {
  if (businessUUID) {
    if (baseURL.slice(-1) == "/") {
      return baseURL + businessUUID + "/"
    } else {
      return baseURL + "/" + businessUUID + "/"
    }
  }

  return baseURL
}

class InsightsHeader extends waffle.base.FilteredComponent {
  handleFiltersChanged(filters, searchString) {
    this.setState({
      summary: null
    });

    var url = getURL("/api/sales/", this.props.businessUUID) + "?filters=" + super.getFilterParameterString(filters, true);
    $.ajax({
      url: url,
      dataType: "json",
      type: "GET"
    }).done((data, textStatus) => {
      this.setState({
        summary: data.data.summary
      });
    }).fail((jqXHR, textStatus, errorThrown) => {
      console.log(errorThrown);
    });

    var url2 = getURL("/api/sales/insights/gross-sales", this.props.businessUUID) + "?filters=" + super.getFilterParameterString(filters, true);
    $.ajax({
      url: url2,
      dataType: "json",
      type: "GET"
    }).done((data, textStatus) => {
      if (data.data) {
        this.setState({
          insightResult: data.data.insightResult
        });
      } else {
        console.log('Failed to get back data for gross-sales');
      }
      
    }).fail((jqXHR, textStatus, errorThrown) => {
      console.log(errorThrown);
    });
  }

  render() {
    var grossSalesDataBlock = <waffle.insights.InsightDataBlock
      header="Gross Sales"
      loading={true}
    />
    var numberDataBlock = <waffle.insights.InsightDataBlock
      header="Number of sales"
      loading={true}
    />

    if (this.state.summary) {
      grossSalesDataBlock = <waffle.insights.InsightDataBlock
        header="Gross Sales"
        primaryValue={this.state.summary.grossSales}
        primaryIsCurrency={true}
        alignRight={true}
        values={[{label:"Total payments:", value: this.state.summary.total, isCurrency: true, showIfZero: true},
          {label:"Tips:", value: this.state.summary.tips*-1, isCurrency: true},
          {label:"Refunds:", value: this.state.summary.refunds, isCurrency: true, showIfZero: true},
          {label:"Vouchers Bought:", value: this.state.summary.vouchersBought*-1, isCurrency: true, showIfZero: false}]}
      />
      numberDataBlock = <waffle.insights.InsightDataBlock
        header="Number of sales"
        primaryValue={this.state.summary.numberOfSales}
        values={[{label:"Card:", value: this.state.summary.cardAmount, isCurrency: true, showIfZero: true},
          {label:"Cash:", value: this.state.summary.cashAmount, isCurrency: true},
          {label:"Vouchers Redeemed:", value: this.state.summary.vouchersRedeemed, isCurrency: true, showIfZero: false}]}
      />
    }

    return <div className="insights-banner">
      <div className="insight-wrapper">
      { grossSalesDataBlock }
      </div>
      <div className="insight-wrapper">
      { numberDataBlock }
      </div>
      <div className="insight-wrapper gross-sales-insight">
        <waffle.insights.Insight
          insightResult={this.state.insightResult}
          title="Gross sales"
          showCalculation={this.props.showCalculation}
          mouseDownEvent={this.props.mouseDownEvent}
          mouseUpEvent={this.props.mouseDownEvent}
        />
      </div>
    </div>
  }
}

class DateDisplay extends waffle.base.FilteredComponent {
  render() {
    var start = moment().format("Do MMM YYYY")
    var end = moment().add(1, 'days').format("Do MMM YYYY")
    if (this.state.filters && this.state.filters.created) {
      start = moment(this.state.filters.created[0]).format("Do MMM YYYY")
      end = moment(this.state.filters.created[1]).format("Do MMM YYYY")
    }
    return <div className="report-date-display">
      5am <span className="date">{start}</span> to 5am <span className="date">{end}</span>
    </div>
  }
}

class SalesReportBlock extends waffle.blocks.SplitBlock {
  getDefaultState() {
    this.oldIndex =  -1;

    return $.extend(super.getDefaultState(), {
      blockClass: "max-width-block",
      tabIndex: 0,
    });
  }

  trackTableViewed(index) {
    if (index != this.oldIndex) {
      this.oldIndex = index;

      switch(index) {
        case 0: {
          waffle.utils.trackFeature("sales_items_report", "reports");
          break;
        }
        case 1: {
          waffle.utils.trackFeature("sales_staff_report", "reports");
          break;
        }
        case 2: {
          waffle.utils.trackFeature("sales_payments_report", "reports");
          break;
        }
      }
    }
  }

  tabChanged(index) {
    this.setState({
      tabIndex: index
    });
  }

  getSplitHeaderContent() {
    return <div className="split-header transaction-header">
      <div className="close-button no-flex" onClick={this.closeSplitView.bind(this)}>
        <i className="icon-arrow-68 no-padding"></i>
      </div>
      <div className="split-title insight-split-title">
        Insight calculated from
      </div>
    </div>
  }

  showCalculation(insightResult) {
    console.log(insightResult);
    this.setState({
      showingSplit: !this.state.showingSplit,
      insightResult: insightResult
    })
  }

  getSplitContent() {
    if (this.state.insightResult) {
      return <div className="transaction-split-content">
        <waffle.insights.InsightCalculationPanel insightResult={this.state.insightResult}/>
      </div>
    } else {
      return
    }
  }

  getContent() {
    this.trackTableViewed(this.state.tabIndex);

    return <div className="sales-report">
      <waffle.reports.DateHeader
      title="Sales report for"/>
      <DateDisplay />
      <InsightsHeader
        businessUUID={this.props.businessUUID}
        showCalculation={this.showCalculation.bind(this)}
        mouseDownEvent={this.mouseDownHandler.bind(this)}
        mouseUpEvent={this.mouseUpHandler.bind(this)}
      />
      <waffle.tabs.Tabs
        tabChanged={this.tabChanged.bind(this)}
        tabIndex={this.state.tabIndex}
      >
        <waffle.tabs.TabPanel title="Products">
          <ProductsTable
            api={getURL("/api/sales/item-report", this.props.businessUUID)}
            isVisible={this.state.tabIndex == 0}
            emptyTable={
              <waffle.tables.EmptyTableView title="No items sold during period!">
                <span>
                  When you sell <a href="/items/">items</a> you will get insights about them here.
                </span>
              </waffle.tables.EmptyTableView>
            }
          />
        </waffle.tabs.TabPanel>
        <waffle.tabs.TabPanel title="Staff">
          <StaffTable
            api={getURL("/api/sales/staff-report", this.props.businessUUID)}
            isVisible={this.state.tabIndex == 1}
            emptyTable={
              <waffle.tables.EmptyTableView title="No staff transacted during period!">
                <span>
                  When your <a href="/items/">staff</a> transact you will get insights about them here.
                </span>
              </waffle.tables.EmptyTableView>
            }
          />
        </waffle.tabs.TabPanel>
        <waffle.tabs.TabPanel title="Payments">
          <PaymentTable
            api={getURL("/api/sales/payment-report", this.props.businessUUID)}
            isVisible={this.state.tabIndex == 2}
            emptyTable={
              <waffle.tables.EmptyTableView title="No payments during period!">
                <span>
                  When you make payments you will see their breakdown and fees here.
                </span>
              </waffle.tables.EmptyTableView>
            }
          />
        </waffle.tabs.TabPanel>
      </waffle.tabs.Tabs>
    </div>
  }
}

SalesReportBlock.defaultProps = {
  "forcePortalWidth": true
}

class FeeDescription extends waffle.base.BaseComponent {
  render() {
    if (this.props.payment.feeDescriptionAmount) {
      if (this.props.payment.feeIsPercent) {
        return <span className="feeDescription faded">
          @ <waffle.misc.FormattedNumber format="0.00" number={this.props.payment.feeDescriptionAmount}/>%
          </span>
      } else {
        return <span className="feeDescription faded">
          @ <waffle.misc.Amount amount={this.props.payment.feeDescriptionAmount}/>
        </span>
      }
    } else {
      return <span/>
    }
  }
}

class EmptyTable extends waffle.base.BaseComponent {
  render() {
    return <div className="empty-data">
      You have not added any { this.props.dataType }, once you add some you will see additional details about them here.
      <a href={ this.props.link }>Add { this.props.dataType } here.</a>
    </div>
  }
}

class PaymentTable extends waffle.tables.Table {
  getDefaultState() {
    return $.extend(super.getDefaultState(), {
      shownUUID: this.props.shownUUID,
      useOffset: true,
      pageSize: 100,
      blockClass: "normal",
      sortedColumn: "type",
      hideNoResults: true,
      useSubItems: true,
      hasResponsive: true
    })
  }

  getResponsiveRowChildren(row, rowIndex) {
    if (row.subItems) {
      var loopIndex = 0;
      return <div className="list">
        {
          row.subItems.map(subItem => {
            loopIndex += 1;
            return <div className="subItem" key={loopIndex}>
              <div className="title">
                { subItem.title }
              </div>
              { this.getResponsiveLineItem("Count", subItem.count, true) }
              { this.getResponsiveLineItem("Total", subItem.total, false) }
              { this.getResponsiveLineItem("Fees", subItem.fees ? subItem.fees * -1 : 0, false, "no-red") }
              { this.getResponsiveLineItem("Net", subItem.net, false) }
            </div>
          })
        }
      </div>
    }
  }

  getResponsiveRow(row, rowIndex) {
    var rowClass = "payment-row";
    if (row.subItems) {
      rowClass += " expandable"
    }

    if (this.state.responsiveExpandedRows[rowIndex]) {
      rowClass += " expanded";
    }

    return <div
      className={ rowClass }
      onClick={ this.expandResponsiveRow.bind(this, rowIndex) }
      key={ rowIndex }
    >
      <span className="title">{ row.title }</span>
      <waffle.misc.Amount amount={row.total}/>
      { this.getResponsiveRowChildren(row, rowIndex) }
    </div>
  }

  getTableClass() {
    return super.getTableClass()
  }

  getHeader() {
    return <tr className="visible-header">
      <th className="ranking"/>
      <th className="payment-type">
        Payment type
      </th>
      <th className="number">
        Count
      </th>
      <th className="amount">
        Total
      </th>
      <th className="amount no-red">
        Fees
      </th>
      <th className="amount">
        Net
      </th>
    </tr>
  }

  rowClicked(rowData) {
    console.log(["clicked me", rowData]);
  }

  getRow(rowData, groupIndex, index) {
    var className = super.getIsLastSubItem(groupIndex, index) ? "underlined-row child-row" : "child-row";

    return <tr
      className={ className }
      onClick={ this.rowClicked.bind(this) }
      key={"row-"+groupIndex}
    >
      <td className="ranking"/>
      <td className="payment-type subtext">
        {rowData.title}
      </td>
      <td className="number subtext">
        <waffle.misc.FormattedNumber
          number={rowData.count}
          alignLeft={true}
          format="0,0"
        />
      </td>
      <td className="amount subtext">
        <waffle.misc.Amount
          amount={rowData.total}
        />
      </td>
      <td className="amount subtext no-red" style={{overflow: "visible"}}>
        <waffle.misc.Amount
          showZeroAsDash={true}
          amount={rowData.fees ? rowData.fees * -1 : 0}
        />
        <FeeDescription payment={rowData}/>
      </td>
      <td className="amount subtext">
        <waffle.misc.Amount
          amount={rowData.net}
        />
      </td>
    </tr>
  }

  getGroupHeader(group, index) {
    var className = group.subItems ? "group-header-row" : "underlined-row";

    return <tr
      className={ className }
      onClick={ this.rowClicked.bind(this) }
      key={ "groupheader-" + index }
    >
      <td className="ranking">
        {index + 1}
      </td>
      <td className="payement-type">
        {group.title}
      </td>
      <td className="number">
        <waffle.misc.FormattedNumber
          number={group.count}
          alignLeft={true}
          format="0,0"
        />
      </td>
      <td className="amount">
        <waffle.misc.Amount
          amount={group.total}
        />
      </td>
      <td className="amount no-red">
        <waffle.misc.Amount
          showZeroAsDash={true}
          amount={group.fees ? group.fees * -1 : 0}
        />
      </td>
      <td className="amount">
        <waffle.misc.Amount
          amount={group.net}
        />
      </td>
    </tr>
  }
}

class StaffTable extends waffle.tables.Table {
  getDefaultState() {
    return $.extend(super.getDefaultState(), {
      shownUUID: this.props.shownUUID,
      useOffset: true,
      pageSize: 100,
      blockClass: "normal",
      sortedColumn: "name",
      hideNoResults: true,
      useSubItems: true,
      hasResponsive: true,
      showTips: false,
      showOther: false
    });
  }

  dataLoaded(data) {
    var showOther = false;
    for (let staff of data.data.staff) {
      if (staff.customAmount > 0) {
        showOther = true;
      }
    }

    this.setState({
      showTips: data.data.hasTips,
      showOther: showOther
    });
  }

  getTableClass() {
    return super.getTableClass()
  }

  getHeader() {
    var tipsRow = null;
    if (this.state.showTips) {
      tipsRow = (<waffle.tables.SortableTableHeader
          column="tips"
          table={this}
          className="amount"
        >
          Tips
        </waffle.tables.SortableTableHeader>);
    }

    var otherRow = null
    if (this.state.showOther) {
      otherRow = <th className="amount">Other</th>
    }

    return <tr className="visible-header">
      <th className="ranking"/>
      <waffle.tables.SortableTableHeader
        column="name"
        table={this}
        className="staff-member"
      >
        Staff member
      </waffle.tables.SortableTableHeader>
      <th className="amount">
        Card
      </th>
      <th className="amount">
        Cash
      </th>
      { otherRow }
      { tipsRow }
      <waffle.tables.SortableTableHeader
        column="total"
        table={this}
        className="amount"
      >
        Total
      </waffle.tables.SortableTableHeader>
    </tr>
  }

  getResponsiveRowChildren(row, rowIndex) {
    if (row.subItems) {
      var loopIndex = 0;
      return <div>
        {
          row.subItems.map(subItem => {
            loopIndex+=1;
            return <div className="subItem" key={loopIndex}>
              <div className="title">
                { subItem.description }
              </div>
              { this.getResponsiveLineItem("Card amount", subItem.cardAmount, false) }
              { this.getResponsiveLineItem("Cash amount", subItem.cashAmount, false) }
              { this.getResponsiveLineItem("Other amount", subItem.customAmount ? subItem.customAmount : 0, false) }
              { this.getResponsiveLineItem("Tip amount", subItem.tipAmount ? subItem.tipAmount * -1 : 0, false, "no-red") }
              { this.getResponsiveLineItem("Total", subItem.total, false) }
            </div>
          })
        }
      </div>
    }
  }

  getResponsiveRow(row, rowIndex) {
    var rowClass = "payment-row expandable";

    if (this.state.responsiveExpandedRows[rowIndex]) {
      rowClass += " expanded";
    }

    return <div
      className={ rowClass }
      onClick={ this.expandResponsiveRow.bind(this, rowIndex) }
      key={ rowIndex }
    >
      <span className="title">{ row.name }</span>
      <waffle.misc.Amount amount={row.total}/>
      <div className="list">
        { this.getResponsiveLineItem("Card amount", row.cardAmount, false) }
        { this.getResponsiveLineItem("Cash amount", row.cashAmount, false) }
        { this.getResponsiveLineItem("Other amount", row.customAmount ? row.customAmount : 0, false) }
        { this.getResponsiveLineItem("Tip amount", row.tipAmount ? row.tipAmount * -1 : 0, false, "no-red") }
        { this.getResponsiveRowChildren(row, rowIndex) }
      </div>
    </div>
  }

  rowClicked(rowData) {
    console.log(["clicked me", rowData]);
  }

  getRow(rowData, index) {
    var className = index == 1 ? "underlined-row" : "";

    var tipsRow = null
    if (this.state.showTips) {
      tipsRow = <td className="amount subtext no-red">
        <waffle.misc.Amount
          showZeroAsDash={true}
          amount={rowData.tipAmount ? rowData.tipAmount * -1 : 0}
        />
      </td>
    }

    var otherRow = null
    if (this.state.showOther) {
      otherRow = <td className="amount subtext">
        <waffle.misc.Amount
          showZeroAsDash={true}
          amount={rowData.customAmount ? rowData.customAmount * -1 : 0}
        />
      </td>
    }

    return <tr
      className={ className }
      onClick={ this.rowClicked.bind(this) }
      key={"row-"+index}
    >
      <td className="ranking"/>
      <td className="staff-member subtext">
        {rowData.description}
      </td>
      <td className="amount subtext">
        <waffle.misc.Amount
          showZeroAsDash={true}
          amount={rowData.cardAmount}
        />
      </td>
      <td className="amount subtext">
        <waffle.misc.Amount
          showZeroAsDash={true}
          amount={rowData.cashAmount}
        />
      </td>
      { otherRow }
      { tipsRow }
      <td className="amount subtext">
        <waffle.misc.Amount
          showZeroAsDash={true}
          amount={rowData.total}
        />
      </td>
    </tr>
  }

  getGroupHeader(group, index) {
    var className = group.subItems ? "" : "underlined-row";

    var tipsRow = null
    if (this.state.showTips) {
      tipsRow = <td className="amount no-red">
          <waffle.misc.Amount
            showZeroAsDash={true}
            amount={group.tipAmount ? group.tipAmount * -1 : 0}
          />
        </td>
    }

    var otherRow = null;
    if (this.state.showOther) {
      otherRow = (<td className="amount">
          <waffle.misc.Amount
            showZeroAsDash={true}
            amount={group.customAmount ? group.customAmount : 0}
          />
        </td>);
    }

    return <tr
      className={ className }
      onClick={ this.rowClicked.bind(this) }
      key={ "groupheader-" + index }
    >
      <td className="ranking">
        {index + 1}
      </td>
      <td className="staff-member">
        {group.name}
      </td>
      <td className="amount">
        <waffle.misc.Amount
          showZeroAsDash={true}
          amount={group.cardAmount}
        />
      </td>
      <td className="amount">
        <waffle.misc.Amount
          showZeroAsDash={true}
          amount={group.cashAmount}
        />
      </td>
      { otherRow }
      { tipsRow }
      <td className="amount">
        <waffle.misc.Amount
          showZeroAsDash={true}
          amount={group.total}
        />
      </td>
    </tr>
  }
}

class ProductsTable extends waffle.tables.Table {
  getDefaultState() {
    return $.extend(super.getDefaultState(), {
      shownUUID: this.props.shownUUID,
      useOffset: true,
      pageSize: 100,
      blockClass: "normal",
      sortedColumn: "amount",
      hideNoResults: true
    })
  }

  getTableClass() {
    return super.getTableClass()
  }

  getHeader() {
    return <tr className="visible-header">
      <th className="ranking"/>
      <waffle.tables.SortableTableHeader
        column="name"
        table={this}
        className="product-name"
      >
        Name
      </waffle.tables.SortableTableHeader>
      <waffle.tables.SortableTableHeader
        column="quantity"
        table={this}
        className="product-quantity"
      >
        Quantity
      </waffle.tables.SortableTableHeader>
      <waffle.tables.SortableTableHeader
        column="amount"
        table={this}
        className="product-total"
      >
        Total
      </waffle.tables.SortableTableHeader>
    </tr>
  }

  rowClicked(rowData) {
    console.log(["clicked me", rowData]);
  }

  getRow(rowData, index) {
    var name = rowData.name;
    var nameClass = "product-name";
    if (!rowData.name) {
      name = rowData.quantity > 1 ? "Custom amounts" : "Custom amount";
      nameClass += " faded";
    }

    return <tr
      className="underlined-row"
      onClick={this.rowClicked.bind(this)}
      key={"row-"+index}
    >
      <td className="ranking">
        {index + 1}
      </td>
      <td className={nameClass}>
        {name}
      </td>
      <td className="product-quantity">
        {rowData.quantity}
      </td>
      <td className="product-total">
        <waffle.misc.Amount
          amount={rowData.amount}
        />
      </td>
    </tr>
  }
}

module.exports = {
  SalesReportBlock: SalesReportBlock
}
